import OptionDetails from "./index";

export function LocalOptionDetails({ question, state, dispatch, details }) {
  return (
    <OptionDetails
      question={question}
      state={state}
      dispatch={dispatch}
      details={details}
    />
  );
}
